import type { RefObject } from 'react';
import { textTransition } from '../../../util/animation/text/text';
import type { TextTransitionType } from '../../../util/animation/text/text.types';
import type { HeadingRef } from './Heading.data';

interface HeadingRefs {
  elementRef: RefObject<HeadingRef | null>;
  transitionInType?: TextTransitionType;
  transitionOutType?: TextTransitionType;
  enableChineseTransitionFallback?: boolean;
  isChineseLanguage: RefObject<boolean | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, transitionInType, enableChineseTransitionFallback, isChineseLanguage }: HeadingRefs,
): void {
  if (elementRef?.current) {
    if (
      enableChineseTransitionFallback &&
      isChineseLanguage.current &&
      transitionInType !== 'none'
    ) {
      timeline.add(textTransition(elementRef.current as HTMLElement, 'fadeIn'));
    } else {
      timeline.add(textTransition(elementRef.current as HTMLElement, transitionInType));
    }
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  {
    elementRef,
    transitionOutType,
    enableChineseTransitionFallback,
    isChineseLanguage,
  }: HeadingRefs,
): void {
  if (elementRef?.current) {
    if (
      enableChineseTransitionFallback &&
      isChineseLanguage.current &&
      transitionOutType !== 'none'
    ) {
      timeline.add(textTransition(elementRef.current as HTMLElement, 'fadeOut'));
    } else {
      timeline.add(textTransition(elementRef.current as HTMLElement, transitionOutType));
    }
  }
}
